import React from "react";
import { connect } from "react-redux";
import DropdownOutside from "./DropdownOutside";
import { changeLanguage } from "../actions/root";

const mapDispatchToProps = () => dispatch => ({
  changeLanguage: l => dispatch(changeLanguage(l))
});

export class SetLanguage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      availableLanguages: [
        { value: "en", label: "English" },
        { value: "se", label: "Svenska" }
      ],
      toggleLangDropdown: false,
      currentLanguague:
        window.localStorage && window.localStorage.language
          ? window.localStorage.language
          : "se"
    };
    this.filterLanguage = this.filterLanguage.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user.language !== this.state.currentLanguague) {
      this.setState({
        currentLanguague: nextProps.user.language
      });
    }
  }

  switchLanguage = lang => {
    this.setState({ currentLanguague: lang.value, toggleLangDropdown: false });
    this.props.changeLanguage(lang.value);
    window.localStorage.language = lang.value;
  };

  filterLanguage = lang => {
    var selected = this.state.availableLanguages.filter(l => {
      return l.value === lang;
    });

    if (selected.length > 0) {
      return selected[0].label;
    }

    return null;
  };

  render() {
    return (
      <DropdownOutside
        onClickOutside={() => {
          this.setState({
            toggleLangDropdown: false
          });
        }}
      >
        <div
          className={`select__wrap profile__language ${
            this.state.toggleLangDropdown ? "open" : ""
          }`}
        >
          <button
            type="button"
            className="select__button button"
            onClick={() => {
              this.setState({
                toggleLangDropdown: !this.state.toggleLangDropdown
              });
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/flags/${this.state.currentLanguague}.png`}
              alt={this.state.currentLanguague}
            />

            {this.filterLanguage(this.state.currentLanguague)}

            <i
              className={`fa ${
                this.state.toggleLangDropdown ? "fa-caret-up" : "fa-caret-down"
              }`}
            />
          </button>

          {this.state.toggleLangDropdown ? (
            <ul className="select__list">
              {this.state.availableLanguages.map((language, i) => (
                <li
                  key={i}
                  className={`select__item select__item--image ${
                    language.value === this.state.currentLanguague
                      ? "active"
                      : ""
                  }`}
                  onClick={() => {
                    this.switchLanguage(language);
                    if (typeof this.props.afterChange === "function") {
                      this.props.afterChange(language.value);
                    }
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/images/flags/${language.value}.png`}
                    alt={language.value}
                  />
                  {language.label}
                </li>
              ))}
            </ul>
          ) : null}
        </div>
      </DropdownOutside>
    );
  }
}

export default connect(
  null,
  mapDispatchToProps
)(SetLanguage);
